// Module
var code = "<terceraTextBox name=\"textBox\" text=\"{{.currentName}}\"/>";
// Exports
export default code;